








































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { DoctorModel } from "@/models/doctor";
import { inject } from 'inversify-props';
import { IUserService, UserType } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

type RegisterResult = {
  model: DoctorModel;
  err?: Error;
};

@Component({})
export class DoctorRegisterModal extends Vue {
  @inject(DependencyIdentifiers.UserService)
  private userService!: IUserService;

  @Prop({ required: true })
  doctors!: DoctorModel[];

  private componentKey = 0;
  private current: RegisterResult | null = null;
  private results: RegisterResult[] = [];

  private get progress() {
    if (this.doctors.length === 0) {
      return 100;
    }
    return (this.results.length / this.doctors.length) * 100;
  }

  private get remaining() {
    return this.doctors.length - this.results.length;
  }

  async mounted() {
    const doctors = [...this.doctors];
    for (let i = 0; i < doctors.length; i++) {
      const result: RegisterResult = { model: { ...doctors[i] } };
      this.current = result;
      this.componentKey++;
      await new Promise(resolve => setTimeout(resolve, 1500));
      try {
        await this.userService.create(UserType.Doctors, result.model.$id as string);
        this.onRegisterSuccess(result);
      } catch (err) {
        result.err = err;
        this.onRegisterFailure(result);
      } finally {
        this.current = null;
      }
      this.results = [result, ...this.results];
    }
    this.onComplete(this.results);
  }

  @Emit("complete")
  onComplete(result: RegisterResult[]) {
    return result;
  }

  @Emit("invitation:success")
  onRegisterSuccess(result: RegisterResult) {
    this.onRegister(result);
    return result;
  }

  @Emit("invitation:failure")
  onRegisterFailure(result: RegisterResult) {
    this.onRegister(result);
    return result;
  }

  @Emit("invitation")
  onRegister(result: RegisterResult) {
    this.componentKey++;
    return result;
  }
}

export default DoctorRegisterModal;
